export default "__VITE_ASSET__DNeubZzl__"